import { DEFAULT_MAX_ITEM_PER_PAGE } from "../core/constants/appGlobals";
import BaseService from "./BaseService";

export type ClientServiceFilterParams = {
  page?: number;
  pageSize?: number;
  client?: string;
  jdeCode?: string;
  codigoLi?: string;
  unit?: string;
  user?: string;
  pageNumber?: number;
};

export default class ClientService {
  fetch() {
    try {
      return new BaseService(true).get("Customer/Clientes");
    } catch (error) {
      console.warn("🚀 ~ file: ClientsService.ts ~ line 7 ~ ClientService ~ fetch ~ error", error);
      return Promise.reject(error);
    }
  }

  filter(filter: ClientServiceFilterParams) {
    try {
      const { page, pageSize, client, jdeCode, codigoLi, unit, user, pageNumber } = filter;

      // FIXME - corrigir comportamento implementando paginação no front e back corretamente
      const usePageSize = pageSize || DEFAULT_MAX_ITEM_PER_PAGE;

      const clientFilter = client ? `&Cliente=${client}` : "";
      const jdeCodeFilter = jdeCode ? `&NumeroJde=${jdeCode}` : "";
      const codigoLiFilter = codigoLi ? `&CodigoLi=${codigoLi}` : "";
      const unitFilter = unit ? `&UnidadeResponsavel=${unit}` : "";
      const userFilter = user ? `&Usuario=${user}` : "";
      const pageNumberFilter = pageNumber ? `&PageNumber=${pageNumber}` : "";

      return new BaseService(true).getPaginated(
        `Customer/ListarClientesFiltrados?PageSize=${usePageSize}${clientFilter}${jdeCodeFilter}${codigoLiFilter}${unitFilter}${userFilter}${pageNumberFilter}`
      );
    } catch (error) {
      console.warn("🚀 ~ file: ClientsService.ts ~ line 7 ~ ClientService ~ fetch ~ error", error);
      return Promise.reject(error);
    }
  }
}
